import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthGuard } from './core/guard/auth.guard';
import { Routes } from '@angular/router';
import { FeatureFlagGuard } from './core/feature-flags/feature-flag.guard';
import { MaintenanceComponent } from './maintenance/pages/maintenance/maintenance.component';

export const AppRoutes: Routes = [
    {
        path: '', redirectTo: '/home', pathMatch: 'full'
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [

            {
                path: 'home',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
            },
            {
                path: 'gerenciamento',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/gerenciamento/gerenciamento.module').then(m => m.GerenciamentoModule)
            },
            {
                path: 'cadastro',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/cadastro/cadastro.module').then(m => m.CadastroModule)
            },
            {
                path: 'operacao',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/operacao/operacao.module').then(m => m.OperacaoModule)
            },
            {
                path: 'credito',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/credito/credito.module').then(m => m.CreditoModule)
            },
            {
                path: 'financeiro',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/financeiro/financeiro.module').then(m => m.FinanceiroModule)
            }, {
                path: 'suporte',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/suporte/suporte.module').then(m => m.SuporteModule)
            }, {
                path: 'ajuda',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/ajuda/ajuda.module').then(m => m.AjudaModule)
            }, {
                path: 'ecv',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/cadastro/ecv/ecv.module').then(m => m.EcvModule)
            },{
                path: 'auditoriaDETRAN',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/auditoriaDetran/auditoriaDetran.module').then(m => m.AuditoriaDetranModule)
            }, {
                path: 'comercial',
                canActivateChild: [AuthGuard],
                loadChildren: () => import('./pages/comercial/comercial.module').then(m => m.ComercialModule)
            }, {
                path: 'nfse',
                canActivate: [FeatureFlagGuard],
                canActivateChild: [AuthGuard],
                data: { featureFlag: 'NFSE' },
                loadChildren: () => import('./pages/nfse/nfse.module').then(m => m.NfseModule)
            }, {
                path: 'dashboard-financeiro',
                canActivateChild: [AuthGuard],
                loadChildren: () =>
                    import('./pages/dashboard-financeiro/dashboard-financeiro.module').then(
                        (m) => m.DashboardFinanceiroModule
                    ),
            },
        ]
    },
    {
        path: 'login',
        loadChildren: () => import('./core/components/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent
    },
    {
        path: 'politica-de-privacidade',
        loadChildren: () =>
            import('./pages/politica-de-privacidade/politica-de-privacidade.module').then(
                (m) => m.PoliticaPrivacidadeModule
            ),
    },
    {
        path: '**', redirectTo: '/home', pathMatch: 'full'
    }
];
